export enum PageScope {
    GLOBAL,
    MODEL,
}
